import Vue from "vue";

export default {
    version: "3.0",
    BASE_URL: 'https://valorinutritie.ro/',
    LANGUAGES: ['RO','EN','GR','ES','IT','HU'], // https://flagicons.lipis.dev/flags/4x3/gr.svg

};
